import React, { useState } from 'react';
import Month from './Month';
import SmallCalendar from './smallCalendar';
import EventsAndHolidays from './EventsAndHolidays';

const Sidebar = () => {
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [selectedDate, setSelectedDate] = useState(new Date());


    // Month names array
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    //   // Navigation functions
    //   const goToPrevMonth = () => {
    //     if (currentMonth === 0) {
    //       setCurrentMonth(11);
    //       setCurrentYear(currentYear - 1);
    //     } else {
    //       setCurrentMonth(currentMonth - 1);
    //     }
    //   };

    //   const goToNextMonth = () => {
    //     if (currentMonth === 11) {
    //       setCurrentMonth(0);
    //       setCurrentYear(currentYear + 1);
    //     } else {
    //       setCurrentMonth(currentMonth + 1);
    //     }
    //   };

    return (
        <div className="w-full bg-white rounded-xl outline outline-1 outline-neutral-200 inline-flex flex-col justify-start items-start">
            {/* Month Header */}
            <div className="self-stretch px-4 py-2.5 border-b border-neutral-200 flex justify-between items-center">
                <div className="inline-flex justify-start items-start gap-2.5">
                    <div className="justify-center text-zinc-800 text-xl font-bold font-['Arial'] capitalize leading-loose">
                        {monthNames[currentMonth]}
                    </div>
                </div>
                {/* <div className="flex gap-2">
                    <button onClick={goToPrevMonth} className="w-6 h-6 flex justify-center items-center text-gray-500">&lt;</button>
                    <button onClick={goToNextMonth} className="w-6 h-6 flex justify-center items-center text-gray-500">&gt;</button>
                </div> */}
            </div>

            {/* Calendar Grid */}
            <SmallCalendar
                month={currentMonth}
                year={currentYear}
                onDateSelect={setSelectedDate}
            />

            {/* Events and Holidays */}
            <EventsAndHolidays
                apiEndpoint="/api/calendar"
                selectedDate={selectedDate}
            />
        </div>
    );
};

export default Sidebar;